
import * as Yup from "yup";
import { buildFormData } from "../../api/helper/buildFormData";
import * as dayjs from 'dayjs'



export const getInitialValues = (objectToEdit: any | null = null): any => {
  //@ts-ignore
  return {
    id: objectToEdit?.id ?? null,
    name: objectToEdit?.name ,
    image: objectToEdit?.image ,
    description: objectToEdit?.description ,


  };
};

export const getInitialValuesForAdd = (objectToEdit: any | null = null): any => {
  return {
    name: null ,
    image: null ,
    description: null ,

    

  };
};

export const getValidationSchema = (editMode: boolean = false): Yup.Schema<any> => {
  // Validate input
  return Yup.object().shape({
    name: Yup.string().required('Required'),
    image: Yup.string().required('Required'),
    description: Yup.string().required('Required'),


  });
};



export const getDataToSend = (values: any): FormData => {
  const data = { ...values };


  const formData = new FormData();
  buildFormData(formData, data);
  return formData;
};

export const ChangeDataToPrint = (data: any) => {

  let new_array = data
  for (let i = 0; i < data.length; i++) {
    new_array[i]['status'] = !data[i]['deleted_at'] ? 'available' : 'unavailable'
    delete new_array[i]['deleted_at']
  }
  return new_array
}